/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Options_Editor_Auto_Chain_EventsInputs */

const en_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Chain Events On Start Time Update`)
};

const fr_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chaîner automatiquement les événements lors de la mise à jour du TC de début`)
};

const de_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automatische Kettenereignisse bei Startzeitaktualisierung`)
};

const it_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi a catena automatica all'aggiornamento dell'ora di inizio`)
};

const ru_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое обновление цепочки событий при запуске`)
};

const es_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización de la hora de inicio de eventos de cadena automática`)
};

const zh_cn2_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动链式事件在开始时间更新`)
};

const ja_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`開始時間更新時の自動チェーンイベント`)
};

const hi_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रारंभ समय अपडेट पर स्वचालित श्रृंखला घटनाएँ`)
};

const pt_pt2_options_editor_auto_chain_events = /** @type {(inputs: Options_Editor_Auto_Chain_EventsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização automática de eventos em cadeia na hora de início`)
};

/**
* | output |
* | --- |
* | "Auto Chain Events On Start Time Update" |
*
* @param {Options_Editor_Auto_Chain_EventsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const options_editor_auto_chain_events = /** @type {((inputs?: Options_Editor_Auto_Chain_EventsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Options_Editor_Auto_Chain_EventsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_options_editor_auto_chain_events(inputs)
	if (locale === "de") return de_options_editor_auto_chain_events(inputs)
	if (locale === "it") return it_options_editor_auto_chain_events(inputs)
	if (locale === "ru") return ru_options_editor_auto_chain_events(inputs)
	if (locale === "es") return es_options_editor_auto_chain_events(inputs)
	if (locale === "zh-CN") return zh_cn2_options_editor_auto_chain_events(inputs)
	if (locale === "ja") return ja_options_editor_auto_chain_events(inputs)
	if (locale === "hi") return hi_options_editor_auto_chain_events(inputs)
	if (locale === "pt-PT") return pt_pt2_options_editor_auto_chain_events(inputs)
	return en_options_editor_auto_chain_events(inputs)
});